import ApiCaller from '../ApiCaller';
import baseAjaxConfig from '../BaseAjaxConfig';
import get from 'lodash/get';
import { pincodeDetailAction } from 'actions/pincodeActions';

export const GET_ORDER_ADDRESSLIST_REQUEST = 'GET_ORDER_ADDRESSLIST_REQUEST';
export const GET_ORDER_ADDRESSLIST_SUCCESS = 'GET_ORDER_ADDRESSLIST_SUCCESS';
export const GET_ORDER_ADDRESSLIST_ERROR = 'GET_ORDER_ADDRESSLIST_ERROR';
export const CHECK_ADDRESS_FEASIBILITY_SUCCESS = 'CHECK_ADDRESS_FEASIBILITY_SUCCESS';
export const CHECK_ADDRESS_FEASIBILITY_ERROR = 'CHECK_ADDRESS_FEASIBILITY_ERROR';
export const ADDRESS_CHANGE_SUCCESS = 'ADDRESS_CHANGE_SUCCESS';
export const ADDRESS_CHANGE_ERROR = 'ADDRESS_CHANGE_ERROR';
export const CREATING_ADDRESS = 'CREATING_ADDRESS';
export const CREATED_ADDRESS = 'CREATED_ADDRESS';
export const ADDRESS_CHANGE_DT_FAILED = 'ADDRESS_CHANGE_DT_FAILED';

export function getOrderAddressList(orderId, token) {
	return dispatch => {
		dispatch(requestAddress());

		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/self-serve/address/all?order_id=${orderId}&token=${token}`
			}),
			{}
		).then(
			json => dispatch(receiveAddressSuccess(json['RESPONSE'])),
			err => {
				dispatch(receiveAddressError(err));
				return Promise.reject(err);
			}
		);
	};
}

export function checkAddressChangeFeasibility(newPincode, token, addressId, type) {
	return dispatch => {
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/self-serve/address/feasible?newPincode=${newPincode}&token=${token}&addressChangeType=${type}`
			}),
			{}
		).then(
			json => dispatch(checkFeasibilitySuccess(newPincode, json['RESPONSE'], addressId, type)),
			err => {
				dispatch(checkFeasibilityError(err));
				return Promise.reject(err);
			}
		);
	};
}

export function requestAddressChange(addressId, token, type) {
	return dispatch => {
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/self-serve/address/confirm?new_address_id=${addressId}&token=${token}&addressChangeType=${type}`
			}),
			{}
		).then(
			json => dispatch(addressChangeSuccess(json['RESPONSE'])),
			err => {
				dispatch(addressChangeError(err));
				return Promise.reject(err);
			}
		);
	};
}

export function createAddress(addressObj, token, type) {
	const postAddress = {
		address_location_tag: addressObj.locationTypeTag || '',
		_pincode: addressObj.pincode,
		name: addressObj.name,
		phone: addressObj.phone,
		addressLine2: addressObj.addressLine1,
		addressLine1: addressObj.addressLine2 || '',
		landmark: addressObj.landmark || '',
		token: token
	};
	return dispatch => {
		dispatch({ type: CREATING_ADDRESS });
		return ApiCaller.put(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/self-serve/address/change/confirm?token=${token}&addressChangeType=${type}`
			}),
			postAddress
		).then(
			json => {
				dispatch(addressChangeSuccess(json['RESPONSE']));
			},
			err => {
				dispatch(receiveAddressError(err));
				return Promise.reject(err);
			}
		);
	};
}

function requestAddress() {
	return { type: GET_ORDER_ADDRESSLIST_REQUEST };
}

function receiveAddressSuccess(response) {
	return { type: GET_ORDER_ADDRESSLIST_SUCCESS, data: response };
}

function receiveAddressError(err) {
	return { type: GET_ORDER_ADDRESSLIST_ERROR, error: err };
}

function checkFeasibilitySuccess(pincode, response, addressId, type) {
	const feasible = get(response, ['feasible']);
	const token = get(response, ['token']);
	return dispatch => {
		if (addressId && feasible) {
			dispatch(requestAddressChange(addressId, token, type));
		} else if (!addressId && feasible) {
			dispatch(pincodeDetailAction(pincode));
		}
		dispatch(setFeasibility(response, addressId));
	};
}

function setFeasibility(response, addressId) {
	return { type: CHECK_ADDRESS_FEASIBILITY_SUCCESS, data: response, addressId: addressId };
}

function checkFeasibilityError(err) {
	return { type: CHECK_ADDRESS_FEASIBILITY_ERROR, error: err };
}

function addressChangeSuccess(response) {
	return { type: ADDRESS_CHANGE_SUCCESS, data: response };
}

function addressChangeError(err) {
	return { type: ADDRESS_CHANGE_ERROR, error: err };
}
